/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../model';
// @ts-ignore
import { GetGroupsResponse } from '../model';
// @ts-ignore
import { GetPermissionsResponse } from '../model';
// @ts-ignore
import { PutGroupRequest } from '../model';
// @ts-ignore
import { PutPermissionsRequest } from '../model';
/**
 * GroupsApi - axios parameter creator
 * @export
 */
export const GroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsByGroup: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPermissionsByGroup', 'id', id)
            const localVarPath = `/api/groups/{id}/permissions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByGroup: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUsersByGroup', 'id', id)
            const localVarPath = `/api/groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoCreate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PutGroupRequest} putGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDoUpdateGroup: async (putGroupRequest: PutGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putGroupRequest' is not null or undefined
            assertParamExists('putDoUpdateGroup', 'putGroupRequest', putGroupRequest)
            const localVarPath = `/api/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutPermissionsRequest} putPermissionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDoUpdatePermissions: async (id: string, putPermissionsRequest: PutPermissionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putDoUpdatePermissions', 'id', id)
            // verify required parameter 'putPermissionsRequest' is not null or undefined
            assertParamExists('putDoUpdatePermissions', 'putPermissionsRequest', putPermissionsRequest)
            const localVarPath = `/api/groups/{id}/permissions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putPermissionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserInGroup: async (id: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeUserInGroup', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeUserInGroup', 'userId', userId)
            const localVarPath = `/api/groups/{id}/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupsApi - functional programming interface
 * @export
 */
export const GroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroups(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroups(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionsByGroup(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionsByGroup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersByGroup(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersByGroup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDoCreate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDoCreate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PutGroupRequest} putGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDoUpdateGroup(putGroupRequest: PutGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDoUpdateGroup(putGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutPermissionsRequest} putPermissionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDoUpdatePermissions(id: string, putPermissionsRequest: PutPermissionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDoUpdatePermissions(id, putPermissionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserInGroup(id: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserInGroup(id, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupsApi - factory interface
 * @export
 */
export const GroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(options?: any): AxiosPromise<GetGroupsResponse> {
            return localVarFp.getGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsByGroup(id: string, options?: any): AxiosPromise<GetPermissionsResponse> {
            return localVarFp.getPermissionsByGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByGroup(id: string, options?: any): AxiosPromise<GetGroupsResponse> {
            return localVarFp.getUsersByGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDoCreate(options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.postDoCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PutGroupRequest} putGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDoUpdateGroup(putGroupRequest: PutGroupRequest, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.putDoUpdateGroup(putGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutPermissionsRequest} putPermissionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDoUpdatePermissions(id: string, putPermissionsRequest: PutPermissionsRequest, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.putDoUpdatePermissions(id, putPermissionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserInGroup(id: string, userId: string, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.removeUserInGroup(id, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPermissionsByGroup operation in GroupsApi.
 * @export
 * @interface GroupsApiGetPermissionsByGroupRequest
 */
export interface GroupsApiGetPermissionsByGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof GroupsApiGetPermissionsByGroup
     */
    readonly id: string
}

/**
 * Request parameters for getUsersByGroup operation in GroupsApi.
 * @export
 * @interface GroupsApiGetUsersByGroupRequest
 */
export interface GroupsApiGetUsersByGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof GroupsApiGetUsersByGroup
     */
    readonly id: string
}

/**
 * Request parameters for putDoUpdateGroup operation in GroupsApi.
 * @export
 * @interface GroupsApiPutDoUpdateGroupRequest
 */
export interface GroupsApiPutDoUpdateGroupRequest {
    /**
     * 
     * @type {PutGroupRequest}
     * @memberof GroupsApiPutDoUpdateGroup
     */
    readonly putGroupRequest: PutGroupRequest
}

/**
 * Request parameters for putDoUpdatePermissions operation in GroupsApi.
 * @export
 * @interface GroupsApiPutDoUpdatePermissionsRequest
 */
export interface GroupsApiPutDoUpdatePermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof GroupsApiPutDoUpdatePermissions
     */
    readonly id: string

    /**
     * 
     * @type {PutPermissionsRequest}
     * @memberof GroupsApiPutDoUpdatePermissions
     */
    readonly putPermissionsRequest: PutPermissionsRequest
}

/**
 * Request parameters for removeUserInGroup operation in GroupsApi.
 * @export
 * @interface GroupsApiRemoveUserInGroupRequest
 */
export interface GroupsApiRemoveUserInGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof GroupsApiRemoveUserInGroup
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof GroupsApiRemoveUserInGroup
     */
    readonly userId: string
}

/**
 * GroupsApi - object-oriented interface
 * @export
 * @class GroupsApi
 * @extends {BaseAPI}
 */
export class GroupsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public getGroups(options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).getGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupsApiGetPermissionsByGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public getPermissionsByGroup(requestParameters: GroupsApiGetPermissionsByGroupRequest, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).getPermissionsByGroup(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupsApiGetUsersByGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public getUsersByGroup(requestParameters: GroupsApiGetUsersByGroupRequest, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).getUsersByGroup(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public postDoCreate(options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).postDoCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupsApiPutDoUpdateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public putDoUpdateGroup(requestParameters: GroupsApiPutDoUpdateGroupRequest, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).putDoUpdateGroup(requestParameters.putGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupsApiPutDoUpdatePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public putDoUpdatePermissions(requestParameters: GroupsApiPutDoUpdatePermissionsRequest, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).putDoUpdatePermissions(requestParameters.id, requestParameters.putPermissionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupsApiRemoveUserInGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    public removeUserInGroup(requestParameters: GroupsApiRemoveUserInGroupRequest, options?: AxiosRequestConfig) {
        return GroupsApiFp(this.configuration).removeUserInGroup(requestParameters.id, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}
